'use strict';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from 'checkout/state';
import CheckoutCart from 'checkout/cart/checkoutCart';
import CheckoutPayment from 'checkout/steps/checkoutPayment';
import CheckoutAddress from 'checkout/steps/checkoutAddress';
import CheckoutTotals from 'checkout/steps/checkoutTotals';
import CheckoutPreview from 'checkout/preview/checkoutPreview';
import CheckoutSuccess from 'checkout/success/checkoutSuccess';

@connect((state) => {
    return {
        cart: state.get('cart'),
        form: state.get('form')
    };
}, (dispatch) => {
    const actions = bindActionCreators(Actions, dispatch);
    return {actions};
})
export default class CheckoutPage extends React.Component {
    renderLoading() {
        return (
            <div className="checkout checkout--loading">
                Bitte Warten
            </div>
        );
    }
    renderCheckoutEmpty() {
        return (
            <div className="checkout checkout--empty">
                Ihr Warenkorb ist leer
            </div>
        );
    }
    onSubmit(foo) {
        console.log('onSubmit', foo);
    }
    validateOrder(e) {
        e.preventDefault();
        this.props.eventEmitter.emit('submitForm');
    }
    render() {
        let {cart, actions} = this.props;

        if (cart.get('success')) {
            return <CheckoutSuccess {...this.props} />;
        }

        if (cart.get('preview')) {
            return <CheckoutPreview {...this.props} />;
        }

        if (cart.get('loading')) {
            return this.renderLoading();
        }

        if (cart.get('products').size === 0) {
            return this.renderCheckoutEmpty();
        }


        return (
            <div className="checkout">
                <h1>Warenkorb</h1>
                <div className="checkout__top">
                    <CheckoutCart cart={cart} actions={actions} />
                    <CheckoutTotals cart={cart} actions={actions} />
                </div>
                <CheckoutPayment cart={cart} actions={actions} />
                <CheckoutAddress onSubmit={this.onSubmit} eventEmitter={this.props.eventEmitter} actions={actions} />
                <div className="checkout__button">
                    <button className="btn" type="button" onClick={::this.validateOrder}>Bestellung überprüfen</button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/checkout/checkoutPage.jsx